module.exports = __webpack_public_path__ + "img/HappyBeach.78e645e1.svg";